module.exports = __webpack_public_path__ + "static/media/nft-single.15dd9cf6.png";